import { render, staticRenderFns } from "./WyrobSurowceList.vue?vue&type=template&id=28009df5&"
import script from "./WyrobSurowceList.vue?vue&type=script&lang=js&"
export * from "./WyrobSurowceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports